import guest from '../middleware/guest';

export default {
    path: '/autorizacija',
    name: 'auth',
    redirect: { name: 'login' },
    meta: {
        middleware: [guest]
    },
    component: () => import('@/views/auth/Auth'),
    children: [
        {
            path: '',
            name: 'login',
            component: () => import('@/components/auth/Login'),
        },
        {
            path: '/forgot-password',
            name: 'forgot-password',
            component: () => import('@/components/auth/ForgotPassword'),
        },
        {
            path: '/reset-password',
            name: 'reset-password',
            component: () => import('@/components/auth/ResetPassword'),
            beforeEnter: (to, from, next) => {
                if (!to.query.token) {
                    next({ name: 'login' });
                } else {
                    next();
                }
            }
        }
    ]
};